import { initStore }    from '../src/store';
import withRematch      from '../src/utils/withRematch';
import Layout           from '../src/containers/MineLayout';
import Business         from '../src/containers/Business';

const BusinessPage = (props) => {
    return (
        <Layout {...props}>
            <Business lang={props.lang}/>
        </Layout>
    );
};

BusinessPage.getInitialProps = async function(ctx) {
    const { pathname, req, store } = ctx;

    let token = req ? req.cookies.token : null;

    await store.dispatch.user.getUserInfoFull({token});


    let curLang = req && req.language ? req.language.split('-')[0] : 'ru';

    return {
        headerClass: '',
        curLang,
        pathname,
        title: 'MOVER: Бизнес',
        description: 'MOVER – ваш личный транспортный отдел. Платформа где вы без лишних вопросов получите профессиональную команду перевозчиков всего в пару кликов. Дешевле на 15-25%, чем по рынку. Интеграция в любую вашу систему управления заказами. Любой вид оплаты, услуги экспедирования, доставка клиенту уже через 3 часа с момента заказа! Подключайтесь к MOVER и получите 3000₽ на бонусный счет.'
    }
};

const mapState = state => ({
    lang: state.lang,
    userInfo: state.user,
    activeOrder: state.orders.activeOrder
});

const mapDispatch = ({ orders: { acceptedOrder, declinedOrder }, user: { getUserInfoFull }, calculator: { searchStop, searchStart, update }, ws: { connect }}) => ({
    getUserInfoFull     :    () => getUserInfoFull(),
    calculatorUpdate:   (data) => update(data),
    wsConnect:          () => { connect() },
    searchStop:         (data) => searchStop(data),
    searchStart:        (data) => searchStart(data),
    acceptedOrder:      (orderId) => acceptedOrder(orderId),
    declinedOrder:      (orderId) => declinedOrder(orderId),
});

export default withRematch(initStore, mapState, mapDispatch)(BusinessPage);
